<template
  ><b-container fluid>
    <b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row
      ><b-col><div class="page_title">Submit Scantron</div></b-col></b-row
    >
    <Scantron
      :course-id="courseRelationship.courseId"
      :exam="exam"
      :color="courseRelationship.color"
    />
    <navigation-alert :next="next" />
    <submit-scantron-modal
      :relationship-id="courseRelationship._id"
      :course-id="courseRelationship.course._id"
      :scantron="exam"
      :color="courseRelationship.color"
    />
  </b-container>
</template>

<script>
import EventBus from "../../services/eventBus/EventBus";
import EventConstants from "../../services/eventBus/EventConstants";
import Scantron from "../../components/Exams/Scantron";
import StoreConstants from "../../store/services/StoreConstants";
import NavigationAlert from "../../components/NavigationAlert";
import SubmitScantronModal from "../../components/Exams/SubmitScantronModal";
import { mapGetters } from "vuex";

export default {
  name: "SubmitScantron",
  components: { SubmitScantronModal, NavigationAlert, Scantron },
  props: {
    relationshipId: {
      type: String,
      default: null
    },
    exam: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      getCourse: StoreConstants.GETTERS.COURSE
    }),
    courseRelationship() {
      return this.getCourse(this.relationshipId);
    }
  },
  data: () => ({
    next: null
  }),
  mounted: function() {
    EventBus.$on(EventConstants.EVENTS.EXAM_SUBMITTED, this.submitExam);
  },
  destroyed() {
    EventBus.$off(EventConstants.EVENTS.EXAM_SUBMITTED);
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "ScoreReport" || !this.courseRelationship) {
      return next();
    }

    this.next = next;
    this.$bvModal.show("navigationAlert");
  },
  methods: {
    submitExam() {
      this.$bvModal.show("submitScantronModal");
    }
  }
};
</script>

<style scoped></style>
